export function disableDevtools() {
    // 禁止右键
    document.addEventListener('contextmenu', e => e.preventDefault())

    // 禁止快捷键
    document.addEventListener('keydown', e => {
        if (e.key === 'F12' || e.keyCode === 123) {
            e.preventDefault()
            return false
        }
        if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) {
            e.preventDefault()
            return false
        }
        if (e.ctrlKey && e.key.toUpperCase() === 'U') {
            e.preventDefault()
            return false
        }
        if (e.ctrlKey && e.key.toUpperCase() === 'S') {
            e.preventDefault()
            return false
        }
    })
}